import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { priceSchema } from './event-sections.schemas';
import { rewardSchema, imageSchema, tsvConfigSchema } from './event-shared-object.schema';

export const gatchaProgressRewardBarSchema = (enums?: EnumParams) =>
  z.object({
    maxTierId: z.number().int().nonnegative().optional(),
    tiers: z.array(
      z.object({
        id: z.number().int().positive().optional(),
        rollsRequired: z.number().int().nonnegative(),
        rewards: rewardSchema(enums).array(),
      }),
    ),
  });

const gatchaBaseSchema = (enums?: EnumParams) => ({
  singleCost: priceSchema(enums),
  bulkCost: priceSchema(enums),
  bulkAmount: z.number().int().nonnegative(),
  dailyFreeAttempts: z.number().int().nonnegative().optional(),
  dailyAdViewAttempts: z.number().int().nonnegative().optional(),
  dailyLimit: z.number().int().nonnegative().optional(),
  showOffersButton: z.boolean(),
  showGrowthFundButton: z.boolean(),
  showExchangeShopButton: z.boolean(),
  showTasksButton: z.boolean(),
  maxPity: z.number().int().nonnegative(),
  softPity: z.number().int().nonnegative().optional(),
  progressRewardBar: gatchaProgressRewardBarSchema(enums),
  heroShowcaseIds: (enums?.HeroShowcaseID
    ? z.array(z.enum(enums.HeroShowcaseID))
    : z.array(z.string())
  ).optional(),
});

export const GATCHA_TYPE_VALUES = ['simple', 'spinner', 'treasureBox'] as const;

export const gatchaSectionSchema = (enums?: EnumParams) =>
  z
    .discriminatedUnion('type', [
      z.object({
        type: z.literal('simple'),
        ...gatchaBaseSchema(enums),
        simpleDisplayConfig: z.object({
          animationSequenceType: enums ? z.enum(enums.AnimationSequenceType) : z.string(),
        }),
      }),
      z.object({
        type: z.literal('spinner'),
        ...gatchaBaseSchema(enums),
        spinnerDisplayConfig: z.object({
          image: imageSchema(enums),
        }),
      }),
      z.object({
        type: z.literal('treasureBox'),
        ...gatchaBaseSchema(enums),
        treasureBoxDisplayConfig: z.object({
          image: imageSchema(enums),
        }),
      }),
    ])
    .and(tsvConfigSchema(enums));
